import src from '../../assets/coins/ton.webp';

type Props = {
  size?: number;
  className?: string;
};

export function TonIcon({ size = 44, className }: Props) {
  return (
    <img
      src={src}
      alt=""
      aria-label="TON"
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 rounded-full object-cover ${className ?? ''}`}
      style={{ width: size, height: size }}
    />
  );
}
